import type { MessageMention } from '@hvf/contracts'
import { createEffect, createResource, createSignal } from 'solid-js'
import { createStore } from 'solid-js/store'
import { userId } from '../auth'
import { handleDeleteMessageMention, handleGetMessageMentions } from './resources'

export function useMessageMention() {
	const [messageMentions, setMessageMentions] = createStore<MessageMention[]>([])

	const [messageMentionsResource] = createResource(userId, handleGetMessageMentions, {
		initialValue: [],
	})

	const [deleteMessageMention, setDeleteMessageMention] = createSignal<string>()

	const [deleteMessageMentionResource] = createResource(
		deleteMessageMention,
		handleDeleteMessageMention,
	)

	createEffect(() => {
		const mesageMentions = messageMentionsResource()
		setMessageMentions(mesageMentions)
	})

	const messageMentionChannelMap = () =>
		messageMentions.reduce<Record<string, MessageMention[]>>((prev, curr) => {
			if (prev[curr.channel_id]) {
				prev[curr.channel_id] = [...prev[curr.channel_id], curr]
			} else {
				prev[curr.channel_id] = [curr]
			}
			return prev
		}, {})

	createEffect(() => {
		if (deleteMessageMentionResource.state === 'ready') {
			setMessageMentions((messages) =>
				messages.filter((m) => m.id !== deleteMessageMentionResource()),
			)
		}
	})

	return {
		messageMentions,
		setMessageMentions, // Already here, perfect!
		messageMentionChannelMap,
		deleteMessageMentionResource,
		setDeleteMessageMention,
	}
}
